/**
 * @file footer-items.js
 * @description Itens do footer da sidebar (CRA)
 */

import { Laptop, Settings, User } from "lucide-react";

/**
 * Itens do footer da sidebar
 */
export const FOOTER_ITEMS = [
  {
    icon: Laptop,
    label: "Suporte",
    id: "suporte",
    href: "https://trendsuport3.glide.page",
    description: "Acessar suporte",
    permission: "Suporte",
    action: "isinsert",
  },
  {
    icon: User,
    label: "Usuários",
    id: "usuarios",
    href: "/usuarios",
    description: "Gerenciar usuários",
    permission: "Usuario",
    action: "islist",
  },
];
